import { useState, useCallback } from 'react';
import { apiRequest } from '../../utils/apiUtils';
import { VenueComplex } from '../../types/venue';

interface UseOwnerComplexReturn {
  complex: VenueComplex | null;
  loading: boolean;
  error: string | null;
  hasComplex: boolean;
  fetchComplex: () => Promise<void>;
}

export const useOwnerComplex = (): UseOwnerComplexReturn => {
  const [complex, setComplex] = useState<VenueComplex | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchComplex = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await apiRequest<{ complex: VenueComplex }>('/complexes/complex');

      if (response.data?.complex) {
        setComplex(response.data.complex);
      } else if (response.error?.includes('No tenés un complejo')) {
        setComplex(null);
        setError(null); // No es error, simplemente no tiene complejo
      } else {
        setError(response.error || 'Error al cargar complejo');
      }
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.error('Error fetching owner complex:', err);
      setError(err.message || 'Error al cargar complejo');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    complex,
    loading,
    error,
    hasComplex: complex !== null,
    fetchComplex,
  };
};
